import { render, staticRenderFns } from "./split_json.vue?vue&type=template&id=29bcf26c&scoped=true"
import script from "./split_json.vue?vue&type=script&lang=js"
export * from "./split_json.vue?vue&type=script&lang=js"
import style0 from "./split_json.vue?vue&type=style&index=0&id=29bcf26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bcf26c",
  null
  
)

export default component.exports